module.exports = __webpack_public_path__ + "assets/img/ru-8a6c71b2.png";